const FilterSettings = () => {
  return <div></div>;
};

export default FilterSettings;
